import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMortarboardLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.27845 8.99449C1.43874 8.59743 1.43877 7.4027 2.27845 7.00564L11.3588 2.71184C11.7647 2.51988 12.2353 2.51988 12.6413 2.71184L21.7216 7.00564C22.4551 7.35248 22.5479 8.30792 22 8.80873V13.0001C22 13.5524 21.5523 14.0001 21 14.0001C20.4477 14.0001 20 13.5524 20 13.0001V9.8086L19 10.2815V14.0001C19 17.8661 15.866 21.0001 12 21.0001C8.13399 21.0001 4.99998 17.8661 4.99998 14.0001V10.2814L2.27845 8.99449ZM17 9.00007H17.0313L19.146 8.00007L12 4.62095L4.85403 8.00007L6.96878 9.00007H6.99998V9.01482L12 11.3792L17 9.01487V9.00007ZM11.3588 13.2883L6.99998 11.2272V14.0001C6.99998 16.7615 9.23856 19.0001 12 19.0001C14.7614 19.0001 17 16.7615 17 14.0001V11.2272L12.6413 13.2883C12.2353 13.4803 11.7647 13.4803 11.3588 13.2883Z"
	})
});
export default SvgMortarboardLine;
